import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./PlacaLandingPage.module.css";

const PlacaLandingPage = () => {
  const [hovered, setHovered] = useState(null); // Estado para detectar qué botón está activo al pasar el mouse

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Seleccione una opción</h1>

      <div className={styles.buttonContainer}>
        <Link to="/placas/terrenos">
          <button
            className={styles.buttonTerreno}
          >
            Terrenos
          </button>
        </Link>

        <Link to="/placas/inmueble">
          <button
            className={styles.buttonInmueble}
          >
            Inmuebles
          </button>
        </Link>

        <Link to="/placas/luxury">
          <button
            className={styles.buttonLuxury}
          >
            Lujosas
          </button>
        </Link>
      </div>

      <h2 className={styles.subtitle}>Nuevos Diseños</h2>
      <div className={styles.buttonContainer}>
        {/* <Link to="/placas/diseno1">
          <button className={styles.buttonDiseno1}>Diseño 1</button>
        </Link> */}

        <Link to="/placas/diseno2">
          <button className={styles.buttonDiseno2}>Diseño 2</button>
        </Link>

        {/* <Link to="/placas/diseno3">
          <button className={styles.buttonDiseno3}>Diseño 3</button>
        </Link> */}

        {/* <Link to="/placas/diseno4">
          <button className={styles.buttonDiseno4}>Diseño 4</button>
        </Link> */}

        {/* <Link to="/placas/story">
          <button className={styles.buttonStory}>Story</button>
        </Link> */}
      </div>
    </div>
  );
};

export default PlacaLandingPage;
